import React from 'react'
import { Container } from 'react-bootstrap'

function Footer() {
  return (
    <Container className="mb-5">
      <hr />
      <div className="text-right">
        <a
          href="https://members.blackjackapprenticeship.com"
          className="text-secondary text-decoration-none mx-3"
        >
          MEMBER PORTAL
        </a>
        <a
          href="https://www.blackjackapprenticeship.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-secondary text-decoration-none"
        >
          PRIVACY POLICY
        </a>
      </div>
    </Container>
  )
}

export default Footer
